import { cl, CustomElement, getHtmlFromUrl } from '@/utils';
import ListHover from '@/components/ListHover';

export default class Pagination extends CustomElement {
  static component = 'b-pagination';

  url = this.getAttribute('url');
  nextButton: HTMLButtonElement;
  nextContainer: HTMLElement;
  listHover: ListHover

  init() {
    this.setNextButton();
    this.listHover = document.querySelector('b-list-hover');
  }

  setNextButton() {
    this.nextButton = this.$('next-button');
    this.nextContainer = this.$('next-container');

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.nextButton.setAttribute('disabled', '');
        cl(this.nextButton).add('loading');
        if (this.nextButton.hasAttribute('data-next-page')) {
          this.loadPage(this.nextButton.getAttribute('data-next-page'));
        }
      });
    }
  }

  async loadPage(page = '2') {
    const query = this.nextButton?.getAttribute('data-query') || window.location.search;
    return getHtmlFromUrl(`${this.url}/${page !== '1' ? 'p'+page : ''}${query}`, 'b-pagination').then(html => {
      if (html) {
        if (page === '1') {
          this.innerHTML = '';
        } else {
          this.nextContainer?.remove();
        }

        const els = Array.from(html.querySelectorAll('[data-el="hover-el"]'));
        this.listHover?.setHovers(els, page === '1');
        Array.from(html.childNodes).forEach((c) => {
          this.append(c);
        })

        this.setNextButton();
      }

      return html ?? null;
    })
  }
}
